<div class="custom-snackbar">
    <div class="custom-snackbar__message">{{ data }}</div>
    <div class="custom-snackbar__action" (click)="snackBarRef.dismiss()">
        <img src="../../../../assets/images/svg/custom-snackbar_cross-white.svg" alt="close" />
    </div>
</div>
